import { Component, OnInit, Input, ChangeDetectorRef, Output, EventEmitter } from '@angular/core';
import { ControlContainer, NG_VALUE_ACCESSOR, NgForm } from '@angular/forms';
import { ValueAccessorHelper } from '@helpers/value-accessor-helper';

@Component({
  selector: 'app-custom-email-textbox',
  templateUrl: './email-textbox.component.html',
  styleUrls: ['./email-textbox.component.css'],
  viewProviders: [{ provide: ControlContainer, useExisting: NgForm }],
  providers: [
    { provide: NG_VALUE_ACCESSOR, useExisting: CustomEmailTextboxComponent, multi: true }
  ],
})

export class CustomEmailTextboxComponent extends ValueAccessorHelper<any> implements OnInit {
  @Input() mlmText: string;
  @Input() name: string;
  @Input() showMLMText: boolean = true;
  @Input() disabled: boolean = false;
  @Input() errorText: string;
  @Input() label: string;
  @Input() value: string;
  @Input() autocomplete: string = 'off';
  @Input() color: string = 'primary';
  @Input() isRequired: boolean = false;
  @Output() onchange: EventEmitter<any> = new EventEmitter();
  @Input() formSubmitted: boolean = false;
  @Input() formControl: any;
  private _maxlength;
  @Input() set maxlength(max) {
    this._maxlength = max && parseInt(max, null) || 0;
  }

  get maxlength() {
    return this._maxlength;
  }

  constructor(private cdf: ChangeDetectorRef) {
    super();
  }

  ngOnInit() {
    try {
      this.cdf.detectChanges();
    } catch (ex) {
      throw ex;
    }
  }


  change() {
    try {
      this.onchange.emit(this.value);
    } catch (ex) {
      throw ex;
    }
  }
}
